/**
 * MOCK Contractor Registry trade taxonomy (docs/design/contractor-registry/spec.md §2.1 — Category
 * is reused as the trade taxonomy, Kind="trade" — SAME entity pattern as question topics / channels
 * / KORA record types / case violation types / permit types). Mirrors caseViolationTypes.ts's shape
 * & role. Seeded with Linn Valley's real 2026 list — 21 trades after the 2026 contractor-list
 * importer re-run added 4 more (services/api/cmd/seed-trade-categories/main.go's tradeSeeds, the
 * live source of truth; ids/labels/order mirrored here exactly so dev-mock + tests match prod).
 *
 * USE_MOCKS-fallback only — every live-aware surface reads trades from the real Kind=trade Category
 * entities instead (listTradeCategoriesLive / listPublicTradeCategoriesLive). This mock list backs
 * the in-memory CATEGORIES array (mockDb.ts) so the Contractor console/public directory render
 * real-looking data in mock mode.
 */
export interface TradeCategory {
  id: string;
  label: string;
}

export const MOCK_TRADE_CATEGORIES: TradeCategory[] = [
  { id: "general-construction", label: "General Construction" },
  { id: "electrical", label: "Electrical" },
  { id: "plumbing", label: "Plumbing" },
  { id: "hvac", label: "Heating & Air Conditioning" },
  { id: "lot-clearing-excavation", label: "Lot Clearing/Excavation" },
  { id: "skid-sheds", label: "Skid Sheds" },
  { id: "accessory-buildings", label: "Accessory Buildings" },
  { id: "houses-residence", label: "Houses/Residence" },
  { id: "manufactured-homes", label: "Manufactured Homes" },
  { id: "roofing", label: "Roofing" },
  { id: "surveyors", label: "Surveyors" },
  { id: "sewer-tanks", label: "Sewer Tanks" },
  { id: "concrete-flat", label: "Concrete/Flat" },
  { id: "metal-work", label: "Metal Work" },
  { id: "tree-trimming", label: "Tree Trimming" },
  { id: "decks", label: "Decks" },
  { id: "masonry-retaining-walls", label: "Masonry/Retaining Walls" },
  // Added for the 2026 contractor-list import (real lake-town trades + the city's catch-all —
  // id="trade-other", NOT "other": "other" collides tenant-wide with the Kind=concern Report-a-
  // Concern catch-all, see seed-trade-categories' doc comment).
  { id: "boat-docks", label: "Boat Docks" },
  { id: "seawalls", label: "Seawalls" },
  { id: "gravel-soil-haul", label: "Gravel/Soil Haul" },
  { id: "trade-other", label: "Other" },
];
